import { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames';

import SliderPlaceholder from './SliderPlaceholder';

import './SliderTrackImage.scss';

const loadedSrcImages = new Map();

const SliderTrackImage = ({ item }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    if (item && loadedSrcImages.get(item.src)) {
      setImageLoaded(true);
    } else {
      setImageLoaded(false);
    }
  }, [item]);

  const handleLoad = () => {
    setImageLoaded(true);
    loadedSrcImages.set(item.src, true);
  };

  const className = classNames('slider-figure', {
    'slider-figure--hidden': !imageLoaded
  });

  return item ? (
    <div className="slider-figure__wrapper">
      {!imageLoaded && <SliderPlaceholder size="desktop" />}
      <figure className={className}>
        <picture className="slider-figure__image">
          <source
            type="image/webp"
            srcSet={item.src.replace('.jpg', '.webp')}
          />
          <source type="image/jpeg" srcSet={item.src} />
          <img alt={item.caption} onLoad={handleLoad} />
        </picture>
        <figcaption>{item.caption}</figcaption>
      </figure>
    </div>
  ) : null;
};

SliderTrackImage.propTypes = {
  item: PropTypes.shape({
    src: PropTypes.string.isRequired,
    caption: PropTypes.string.isRequired
  }).isRequired
};

export default SliderTrackImage;
